import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const UPDATE_INVOICE = gql`
  mutation UpdateConsultantInvoice($updatedInvoice: UpdateConsultantInvoiceRequestDto!) {
    updateConsultantInvoice(updatedInvoice: $updatedInvoice) {
      uuid
      invoiceDate
      periodStart
      periodEnd
      paymentDate
      clientName
      invoiceNumber
      currency
      dailyRateConsultant
      dailyRateClient
      daysWorked
      commission
      manualCommission
      month
        year
      amountConsultant
      amountClient
      boondManagerInvoiceId
    }
  }
`;

export const useUpdateInvoice = () => {

  const [updateInvoice, { loading, error, data }] = useMutation(UPDATE_INVOICE);

  return { updateInvoice, loading, error, data };
};
